import { FC, ReactNode, createContext } from 'react';
import { useBookitupMailFolderCounts } from '../hooks/useBookitupMailFolderCounts';
import { BookitupEmailsCountsProps } from '../../Types/MailT';

export const PostboxCountersContext = createContext<BookitupEmailsCountsProps>({} as BookitupEmailsCountsProps);

export const PostboxCountersProvider: FC<{ children: ReactNode; contactsIds?: number[] | null }> = ({
  children,
  contactsIds,
}) => {
  const value = useBookitupMailFolderCounts(contactsIds);

  return <PostboxCountersContext.Provider value={value}>{children}</PostboxCountersContext.Provider>;
};
